import { Archive } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, setGroupArchived } from './groupOpsApi'

/**
 * A4.31 — Chatni arxivlash. Chatni arxivga o'tkazadi. JONLI `/admin/groups`
 * ro'yxati; mutatsiya endpoint chiqqach jonli.
 */
export function GroupArchive() {
  return (
    <GroupActionList
      screenId="A4.31"
      title={S.archive}
      description={S.archiveNote}
      actionId="archive"
      actionLabel={S.archive}
      actionIcon={<Archive size={13} />}
      emptyIcon={<Archive size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      successMsg={S.archived}
      run={async (r) => {
        if (!window.confirm(S.archiveConfirm)) return false
        await setGroupArchived(r.id, true)
        return true
      }}
    />
  )
}
